// frontend/src/components/MmiTrendChart.tsx
import React from "react";
import { AgCharts } from "ag-charts-react";
import "ag-charts-enterprise";
import type { AgChartOptions, AgPieSeriesOptions } from "ag-charts-enterprise";
import { useAppSelector } from "../../app/hooks";
import { selectHttpPostMcbimTrendByKey } from "./singleMcbimItemSelectors";

export const MmiTrendChart: React.FC = () => {
  const data = useAppSelector(selectHttpPostMcbimTrendByKey);

  if (data == null) {
    return <div>Ingen trenddata tilgjengelig.</div>;
  }
  const chartData = data.map((point) => ({
    date: new Date(point.date),
    value: point.series.length > 0 ? Number(point.series[0].value) : null,
  }));

  const options: AgChartOptions = {
    data: chartData,
    height: 300,
    series: [
      {
        type: "line",
        xKey: "date",
        yKey: "value",
        marker: { size: 8 },
        tooltip: {
          renderer: ({ datum }: { datum: { date: Date; value: number | null } }) => ({
            title: datum.date.toLocaleDateString(),
            content: `MMI: ${datum.value ?? "N/A"}`,
          }),
        },
      },
    ],
    axes: [
      {
        type: "time",
        position: "bottom",
        label: { format: "%b %Y" },
      },
      {
        type: "number",
        position: "left",
        title: { text: "MMI" },
        min: 0,
        max: 600,
      },
    ],
    legend: { enabled: false },
  };

  return <AgCharts options={options} />;
};
